import { create } from 'zustand'
import type { InboxItem } from '@/services/listingsService'

/**
 * Store de "lead pendiente de abrir" — puente para abrir la ficha del prospecto
 * (LeadSlideOver) desde CUALQUIER página. El command palette (⌘K) vive en el
 * topbar (Inicio/Búsqueda/Plan), así que al elegir un lead deja aquí el item y
 * navega a Búsqueda; la página de Búsqueda lo consume y abre la ficha.
 *
 * Se pasa el `InboxItem` completo (no solo el place_id) para que la ficha se
 * abra aunque el lead no esté en la página actual de la tabla.
 */
interface LeadViewStore {
  pendingLead: InboxItem | null
  /** Solicita abrir la ficha de un lead (lo consumirá la página de Búsqueda). */
  requestLead: (lead: InboxItem) => void
  /** La página de Búsqueda lo llama tras abrir la ficha. */
  consumeLead: () => void
}

export const useLeadView = create<LeadViewStore>((set) => ({
  pendingLead: null,
  requestLead: (lead) => set({ pendingLead: lead }),
  consumeLead: () => set({ pendingLead: null }),
}))
